export default "__VITE_ASSET__DJTvKibF__"